"use client";
import type { TournamentsListState } from "@casino/legacy/client/features/Tournaments/hooks/useTournaments/TournamentsSectionState";
import Tournaments from "@casino/legacy/client/features/Tournaments/modules/TournamentLists";
import LazyInView from "@casino/legacy/client/shared/LazyLoad/Lazy/LazyInView";

type Props = {
  initial?: TournamentsListState;
};

const TournamentsComponent: FC<Props> = ({ initial }) => (
  <LazyInView>
    <Tournaments initial={initial} />
  </LazyInView>
);

export default TournamentsComponent;
